/// <amd-module name="Pipeline/Analytics/PipelineAnalyticsHeader/Sources/BranchSource" />
import { ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";
import { IODataQueryResponse, IReportContext, Period, TrendBy } from "Analytics/Shared/Common/Types";
import { getDateFilter } from "Analytics/Shared/Common/Utils/DateAdjuster";
import { IFilterItem } from "Analytics/Shared/TrendChart/Common/Types";
import { PipelineReportSource } from "Pipeline/Analytics/Common/Sources/PipelineReportSource";
import { PullRequestBranchName, PullRequestBranchPlaceHolderSK, PullRequestBranchPrefix } from "Pipeline/Analytics/Common/Types";
import { IVssPageContext } from "VSS/Platform/Context";

export interface IODataBranchInfo {
    BranchSK: number;
    Branch: {
        BranchName: string;
    };
}

export class BranchSource extends PipelineReportSource {
    constructor(pageContext: IVssPageContext) {
        super("PipelineAnalytics_BranchSource", pageContext);
    }

    public queryBranches(reportContext: IReportContext, period: Period): Promise<IFilterItem[]> {
        const projectId = super._getProjectId();
        const queryOptions = {
            entityType: this._buildEntityName,
            project: projectId
        } as ODataQueryOptions;

        const filterStr = `filter(${this._getPipelineContextFilter(reportContext)} and ${getDateFilter(TrendBy.Days, period)})`;
        const groupByStr = `groupby((${this._getGroupByBranch()}))`;
        queryOptions.$apply = `${filterStr}/${groupByStr}`;

        return this._queryBranchData(queryOptions, period);
    }

    private async _queryBranchData(queryOptions: ODataQueryOptions, period: Period): Promise<IFilterItem[]> {
        const branchInfo = [] as IFilterItem[];

        const data = await this.queryOData(queryOptions);
        if (!data || !data.value) {
            throw new Error("Data is empty");
        }

        let isPullRequestBranchAdded = false;
        (data.value as IODataBranchInfo[]).forEach(d => {
            if (d.Branch && d.Branch.BranchName) {
                if (
                    d.Branch.BranchName.toLowerCase()
                        .trim()
                        .startsWith(PullRequestBranchPrefix)
                ) {
                    // Add single merged entry for all pull request branches.
                    if (!isPullRequestBranchAdded) {
                        branchInfo.push({ id: PullRequestBranchPlaceHolderSK, name: PullRequestBranchName });
                        isPullRequestBranchAdded = true;
                    }
                } else {
                    branchInfo.push({ id: d.BranchSK, name: d.Branch.BranchName });
                }
            }
        });

        return branchInfo;
    }
}
